import type { ListStylesType } from '@material-tailwind/react';

const styles: ListStylesType = {
  defaultProps: {},
  styles: {
    base: {
      list: {},
      item: {
        initial: {
          hover: 'hover:bg-blue-50',
          cursor: 'cursor-pointer',
          spacing: 'py-2 px-3',
        },
        selected: {
          colors: 'bg-gray-100',
        },
      },
    },
  },
};

export default styles;
